import { InjectionToken, inject } from '@angular/core';

import { WINDOW } from './window/window.token';

/**
 * A DI Token to safely access the IntersectionObserver.
 * In the browser it will resolve to the global IntersectionObserver and on the server it will resolve to a stub.
 */
export const INTERSECTION_OBSERVER = new InjectionToken<typeof IntersectionObserver>('IntersectionObserverToken', {
    providedIn: 'root',
    factory: () => inject(WINDOW)['IntersectionObserver'],
});
